import { render, staticRenderFns } from "./BattleModal.vue?vue&type=template&id=7f322a10&scoped=true"
import script from "./BattleModal.vue?vue&type=script&lang=js"
export * from "./BattleModal.vue?vue&type=script&lang=js"
import style0 from "./BattleModal.vue?vue&type=style&index=0&id=7f322a10&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f322a10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cmdgame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f322a10')) {
      api.createRecord('7f322a10', component.options)
    } else {
      api.reload('7f322a10', component.options)
    }
    module.hot.accept("./BattleModal.vue?vue&type=template&id=7f322a10&scoped=true", function () {
      api.rerender('7f322a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/exploration/BattleModal.vue"
export default component.exports